<div
  class="p-container"
  infiniteScroll
  [scrollWindow]="true"
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="150"
  [infiniteScrollDisabled]="isLoading"
  (scrolled)="loadMore()"
>
  <div class="p-6">
    <h2 class="text-2xl font-bold text-gray-800 mb-6">Pre Assessments</h2>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div
        *ngFor="let item of assessmentSummary"
        (click)="viewDietSummary(item)"
        class="group cursor-pointer bg-card rounded-2xl shadow-md hover:shadow-xl transition duration-300 p-6 border border-gray-100 hover:border-blue-300"
      >
        <!-- Top Section -->
        <div class="flex gap-5 items-center mb-4">
          <div class="bg-blue-100 p-3 rounded-xl">
            <i class="pi pi-file-edit text-lg"></i>
          </div>

          <div>
            <!-- Title -->
            <h3 class="text-lg font-semibold text-foreground mb-3">Pre Assessment</h3>

            <!-- Date -->
            <div class="flex items-center text-gray-500 text-sm">
              <i class="pi pi-calendar mr-2 text-gray-400"></i>

              {{ item.created_date | date: 'mediumDate' }}
            </div>
          </div>
        </div>

        <!-- Button -->
        <button
          class="mt-6 w-full bg-primary text-white text-sm py-2 rounded-lg transition flex items-center justify-center gap-2"
        >
          <i class="pi pi-eye"></i>
          Check Diet Summary
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="isLoading" class="text-center py-4">
    <i class="pi pi-spin pi-spinner text-blue-500 text-xl"></i>
  </div>
</div>
